import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

function OAuthCallback({ onLogin }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');

    if (token) {
      // Store token
      localStorage.setItem('token', token);

      // Fetch user data
      fetch(`${process.env.REACT_APP_API_URL || '/api'}/auth/me`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            const user = data.data.user;
            localStorage.setItem('user', JSON.stringify(user));
            if (onLogin) onLogin(user);
            navigate('/');
          } else {
            throw new Error('Failed to fetch user data');
          }
        })
        .catch(err => {
          console.error('OAuth callback error:', err);
          localStorage.removeItem('token');
          navigate('/login');
        });
    } else {
      // No token found, redirect to login
      navigate('/login');
    }
  }, [searchParams, navigate, onLogin]);

  return (
    <div className="container">
      <div className="row justify-content-center mt-5">
        <div className="col-md-6 text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3">Completing sign in...</p>
        </div>
      </div>
    </div>
  );
}

export default OAuthCallback;
